import api from "./api";

const binanceService = {
  getDepositAddress: (jwttoken, coin) =>
    api.get(`/binance/getDepositAddress`, {
      params: { coin },
      headers: { Authorization: `Bearer ${jwttoken}` },
    }),
  registerCashInTransaction: (jwttoken, active_id, tx_id, address_to) =>
    api.post(
      `/binance/registerCashInTransaction`,
      {
        active_id,
        tx_id,
        address_to,
      },
      {
        headers: { Authorization: `Bearer ${jwttoken}` },
      }
    ),
  registerCashOutTransaction: (jwttoken, active_id, amount, address_to, password) =>
    api.post(
      `/binance/registrateCashOutTransaction`,
      {
        active_id,
        amount,
        address_to,
        password
      },
      {
        headers: { Authorization: `Bearer ${jwttoken}` },
      }
    ),
};

export default binanceService;
